import { Link } from "react-router-dom";
import ProjectCard from "./ProjectCard";
import React from "react";
import content from "../../generated/content.json";
import { getMergedProjects } from "./projectsData";
import { useLocale } from "../../i18n/LocaleProvider";
import { useT } from "../../i18n/useT";

const Projects = () => {
  const { lang } = useLocale();
  const t = useT();
  const projects = getMergedProjects(lang, content).slice(0, 3);

  return (
    <section className="p-3 p-lg-5 d-flex flex-column" id="side-projects">
      <h1 className="text-uppercase mb-4">{t("sections.projects.title")}</h1>
      <div className="row g-4">
        {projects.map((project) => (
          <div className="col-md-4" key={project.slug}>
            <ProjectCard project={project} />
          </div>
        ))}
      </div>
      <div className="mt-4">
        <Link to={`/${lang}/projects`}>{t("sections.projects.viewAll")}</Link>
      </div>
    </section>
  );
};

export default Projects;
